import {
	GET_BILLING_TYPES,
	GET_INSTALLMENT_PLANS,
	GET_PLAN_CATEGORIES,
	GET_PLAN_LOCATIONS,
	GET_RELEASE_NOTES,
	GET_SERVICE_MODELS,
	GET_SYSTEM_COUNTRIES,
} from "../actions/domain.actions";

let initialState = {
	planCategories: [],
	billingTypes: [],
	planLocations: [],
	serviceModels: [],
	installmentPlans: [],
	countries: [],
	states: [],
	releaseNotes: {data: "", error:""}
};

export const domainReducer = (state = initialState, action) => {

	switch (action.type) {
		case GET_PLAN_LOCATIONS.SUCCESS:
			return {
				...state,
				planLocations: action.payload
			};
		case GET_PLAN_LOCATIONS.EMPTY:
			return {
				...state,
				planLocations: []
			}
		case GET_PLAN_CATEGORIES.SUCCESS:
			return {
				...state,
				planCategories: action.payload
			};
		case GET_PLAN_CATEGORIES.EMPTY:
			return {
				...state,
				planCategories: []
			}
		case GET_SERVICE_MODELS.SUCCESS:
			return {
				...state,
				serviceModels: action.payload
			};
		case GET_SERVICE_MODELS.EMPTY:
			return {
				...state,
				serviceModels: []
			};
		case GET_INSTALLMENT_PLANS.SUCCESS:
			return {
				...state,
				installmentPlans: action.payload.installmentPlans
			};
		case GET_INSTALLMENT_PLANS.EMPTY:
			return {
				...state,
				installmentPlans: []
			};
		case GET_SYSTEM_COUNTRIES.SUCCESS:
			return {
				...state,
				countries: action.payload.countries
			};
		case GET_SYSTEM_COUNTRIES.EMPTY:
			return {
				...state,
				countries: [ { code3: 'USA', name: "USA" } ]
			};
		case GET_RELEASE_NOTES.SUCCESS:
			return {
				...state,
				releaseNotes: {data: action.payload.data}
			};
		case GET_RELEASE_NOTES.FAILURE:
			return {
				...state,
				releaseNotes: {error: action.payload.message}
			};
		case GET_RELEASE_NOTES.EMPTY:
			return {
				...state,
				releaseNotes: {data:""}
			};

		case GET_BILLING_TYPES.SUCCESS:
			return {
				...state,
				billingTypes: action.payload
			};
		case GET_BILLING_TYPES.EMPTY:
			return {
				...state,
				billingTypes: []
			}
		default:
			return state;
	}
};
